import React from 'react';

const Loading = ({ message = 'Chargement…' }) => (
  <div className="loading" aria-live="polite" aria-label={message}>
    <div style={{ position: 'relative', width: 44, height: 44 }}>
      <div style={{
        position: 'absolute', inset: 0,
        border: '3px solid transparent',
        borderTopColor: 'var(--primary)',
        borderRightColor: 'rgba(0,201,167,.3)',
        borderRadius: '50%',
        animation: 'spin 0.8s linear infinite',
      }}/>
      <div style={{
        position: 'absolute', inset: 7,
        border: '2px solid transparent',
        borderTopColor: 'rgba(0,201,167,.4)',
        borderRadius: '50%',
        animation: 'spin 1.3s linear infinite reverse',
      }}/>
    </div>
    {message && (
      <span style={{ fontSize: '0.82rem', color: 'var(--text-2)', fontWeight: 500 }}>
        {message}
      </span>
    )}
  </div>
);

export default Loading;